var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardOnFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68 19.7105H22.055C24.504 19.7105 25.735 18.504 25.735 16.09V3.633C25.735 1.219 24.504 0 22.055 0H3.68C1.231 0 0 1.219 0 3.633V16.09C0 18.504 1.2305 19.7105 3.68 19.7105ZM1.887 3.739C1.887 2.52 2.5435 1.8875 3.715 1.8875H22.0315C23.1915 1.8875 23.848 2.52 23.848 3.739V4.723H1.887V3.739ZM3.715 17.825C2.543 17.825 1.887 17.2035 1.887 15.985V7.383H23.848V15.9845C23.848 17.203 23.1915 17.8245 22.0315 17.8245L3.715 17.825ZM5.0625 14.3555H7.934C8.6255 14.3555 9.0825 13.8985 9.0825 13.2305V11.0625C9.0825 10.4065 8.6255 9.9375 7.934 9.9375H5.0625C4.371 9.9375 3.914 10.4065 3.914 11.0625V13.2305C3.914 13.8985 4.371 14.3555 5.0625 14.3555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOnFile);
export default __webpack_public_path__ + "static/media/card-on-file.c4ef4c4763c1badd0625d3682b2968fa.svg";
export { ForwardRef as ReactComponent };